import React, { Component, useState } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import ModalHeader from 'react-bootstrap/esm/ModalHeader';
// import { ModalBody, ModalFooter } from 'react-bootstrap';




   
    export default class ModalBody extends Component{
        constructor(props) {
            super(props);
            this.state = {
              modalShow: '',
              display: 'none'
            }
            };
        render() {
            return (
                // <div className="modal-body modalbodys">{this.props.children}</div>
                <div className={this.props.Style}>{this.props.children}</div>
                   
                )
        }
        
    }
    


    
   
